export default "__VITE_ASSET__BrnlRqOZ__"